import React, { useEffect, useState } from 'react';
import branchService from 'ApiService/SuperAdmin/branchService';

const BranchFilter = ({ onBranchChange }) => {
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await branchService.allBranches();
        setBranches(response.data.allBranches);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching branches:', error);
        setLoading(false);
      }
    };

    fetchBranches();
  }, []);

  const handleBranchChange = (event) => {
    const branchId = event.target.value;
    setSelectedBranch(branchId);
    onBranchChange(branchId);
  };

  if (loading) return <div>Loading branches...</div>;

  return (
    <select
      className="rounded border px-2 py-1 dark:bg-navy-700"
      onChange={handleBranchChange}
      value={selectedBranch}
    >
      <option value="">All Branches</option>
      {branches.map((branch) => (
        <option key={branch._id} value={branch._id}>
          {branch.name.charAt(0).toUpperCase() + branch.name.slice(1)} (
          {branch.location.charAt(0).toUpperCase() + branch.location.slice(1)})
        </option>
      ))}
    </select>
  );
};

export default BranchFilter;
